import { fonts } from 'app/styles';
import { Platform } from 'react-native';

export default (colors: any, style: any): any => {
  const mb = style?.pMargin || 16;
  const headingMargin = 10;
  return {
    body: {
      fontFamily: 'Georgia',
      fontSize: 18,
      lineHeight: 28,
      color: colors.black,
      ...(style?.body || {}),
    },
    heading1: {
      fontSize: 32,
      lineHeight: 54,
      fontFamily: fonts.HELVETICA_NEUE_BOLD,
      marginVertical: headingMargin,
    },
    heading2: {
      fontSize: 24,
      fontFamily: fonts.HELVETICA_NEUE_CONDENSED_BOLD,
      marginVertical: headingMargin,
    },
    heading3: {
      fontSize: 20,
      fontFamily: fonts.HELVETICA_NEUE_BOLD,
      marginVertical: headingMargin,
    },
    heading4: {
      fontSize: 18,
      fontFamily: fonts.HELVETICA_NEUE_CONDENSED_BOLD,
      marginVertical: headingMargin,
    },
    heading5: {
      fontSize: 18,
      fontFamily: fonts.HELVETICA_NEUE_CONDENSED_BOLD,
      marginVertical: headingMargin,
    },
    link: {
      color: colors.blue,
      textDecorationLine: 'none',
    },
    blockquote: {
      borderLeftColor: '#DDDDDD',
      backgroundColor: 'transparent',
      paddingVertical: 0,
      borderLeftWidth: 4,
      paddingLeft: 16,
      opacity: 1,
      marginLeft: 0,
      marginVertical: mb / 2,
    },
    code_block: {
      backgroundColor: 'rgba(27,31,35,.05)',
      borderWidth: 0,
      borderRadius: 3,
      fontSize: 15,
      fontFamily: Platform.OS === 'ios' ? 'Menlo' : 'monospace',
    },
    code_inline: {
      backgroundColor: 'rgba(27,31,35,.05)',
      borderRadius: 3,
      borderWidth: 0,
      fontSize: 15,
      paddingVertical: 4,
      fontFamily: Platform.OS === 'ios' ? 'Menlo' : 'monospace',
    },
    image: {
      minWidth: 200,
    },
    fence: {
      borderWidth: 0,
      backgroundColor: 'rgba(27,31,35,.05)',
      borderRadius: 3,
      fontSize: 15,
      marginVertical: mb / 2,
      fontFamily: Platform.OS === 'ios' ? 'Menlo' : 'monospace',
    },
    paragraph: {
      marginVertical: mb / 2,
    },
    inline: {
      marginBottom: 0,
    },
    bullet_list: {
      marginVertical: mb / 2,
    },
    ordered_list: {
      marginVertical: mb / 2,
    },
    list_item: {
      marginVertical: mb / 2,
    },
  };
};
